'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var algo = require('./algo.js');
var aptos = require('./aptos.js');
var ars = require('./ars.js');
var aud = require('./aud.js');
var avax = require('./avax.js');
var brl = require('./brl.js');
var btc = require('./btc.js');
var cad = require('./cad.js');
var chf = require('./chf.js');
var cusdc = require('./cusdc.js');
var eth = require('./eth.js');
var eur = require('./eur.js');
var eurc = require('./eurc.js');
var flow = require('./flow.js');
var gbp = require('./gbp.js');
var hkd = require('./hkd.js');
var idr = require('./idr.js');
var inr = require('./inr.js');
var jpy = require('./jpy.js');
var mana = require('./mana.js');
var matic = require('./matic.js');
var mxn = require('./mxn.js');
var sgd = require('./sgd.js');
var sol = require('./sol.js');
var sui = require('./sui.js');
var trx = require('./trx.js');
var usd = require('./usd.js');
var usdc = require('./usdc.js');
var xlm = require('./xlm.js');
var xrp = require('./xrp.js');

/**
 * Default money options.
 */ const defaultMoneyOptions = {
    symbol: true,
    padded: true,
    signDisplay: false,
    condensed: false
};
/**
 * Supported Currency Variants.
 */ const variants = {
    ALGO: algo.default,
    APTOS: aptos.default,
    ARS: ars.default,
    AVAX: avax.default,
    BTC: btc.default,
    CUSDC: cusdc.default,
    ETH: eth.default,
    EUR: eur.default,
    EURC: eurc.default,
    FLOW: flow.default,
    GBP: gbp.default,
    MANA: mana.default,
    MATIC: matic.default,
    SOL: sol.default,
    SUI: sui.default,
    TRX: trx.default,
    USD: usd.default,
    USDC: usdc.default,
    XLM: xlm.default,
    XRP: xrp.default,
    JPY: jpy.default,
    CAD: cad.default,
    MXN: mxn.default,
    AUD: aud.default,
    BRL: brl.default,
    CHF: chf.default,
    INR: inr.default,
    IDR: idr.default,
    HKD: hkd.default,
    SGD: sgd.default
};

exports.default = variants;
exports.defaultMoneyOptions = defaultMoneyOptions;
//# sourceMappingURL=index.js.map
